import { TextInput } from "@mantine/core";
import { IconAlertCircleFilled } from "@tabler/icons-react";
import styles from "./AppTextInput.module.css";

export default function AppTextInput({ label, required, error, ...inputProps }) {
  const isError = Boolean(error);

  return (
    <div className={styles.wrapper}>
      <label className={styles.label}>
        {label}
        {required && <span className={styles.required}>*</span>}
      </label>

      <TextInput
        {...inputProps}
        rightSection={isError ? <IconAlertCircleFilled size={40} color="#89251A" /> : null}
        rightSectionWidth={72}
        styles={{
          input: {
            height: "91.116px",
            paddingLeft: "27.335px",
            paddingRight: "27.335px",
            borderRadius: "18.223px",
            fontFamily: "Urbanist, sans-serif",
            fontSize: "28px",
            fontWeight: 400,
            background: isError ? "#FAD8D5" : "#FFFFFF",
            border: isError ? "2.278px solid #E43E2B" : "2px solid #E0E0E0",
            "::placeholder": {
              color: "#B3B3B3",
              fontFamily: "Oxanium, sans-serif",
              fontSize: "32px",
              fontWeight: 400,
              lineHeight: "normal",
            },
          },
          rightSection: {
            paddingRight: "27.335px",
            display: "flex",
            alignItems: "center",
          },
        }}
      />

      {isError && <span className={styles.errorText}>{error}</span>}
    </div>
  );
}
